import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { StyledUploadImage } from "../../styled";
import { formatFileSize } from "../../utils";
import Typography from "@mui/material/Typography";

type PreviewImageProps = {
  imgUrl: string;
  fileSize?: number | null;
};

const PreviewImage: FC<PreviewImageProps> = ({ imgUrl, fileSize }) => {
  return (
    <FlexCenter columnGap={"0.5rem"}>
      <StyledUploadImage>
        <img src={imgUrl} alt="uploaded" />
      </StyledUploadImage>
      {fileSize && (
        <Typography variant="bodyMRegular">
          {formatFileSize(fileSize)}
        </Typography>
      )}
    </FlexCenter>
  );
};

export default PreviewImage;
